import { PrimaryProductKeys } from '../../../../common/constants/primary-product-keys';
import type { PrimaryProductKey } from '../../../../common/constants/product-keys';

export const getUrsProductKey = (primaryProduct?: PrimaryProductKey): 'confluence' | 'jira' => {
	// URS (User Recommendation Service) only supports 'confluence' and 'jira' as product keys.
	// Other values (e.g. 'townsquare', 'mercury') cause a 400 deserialization error.
	// Default to 'confluence' when the primary product is not one of these two.
	return primaryProduct === PrimaryProductKeys.Jira ||
		primaryProduct === PrimaryProductKeys.Confluence
		? primaryProduct
		: PrimaryProductKeys.Confluence;
};
